import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { HttpMethods, SERVICES } from '../../services/api';
import apiAsyncThunkCreator from '../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../rootReducer';
import { buildQueryParams, ListParams } from '../utils';
import { IUser } from './user';
import { FilterOperators, Ifilter } from '../../components/common/filters/interfaces';

export const fetchUsersList: AsyncThunk<{ users: IUser[] }, ListParams<Ifilter[]>, ThunkAPI> = createAsyncThunk(
  'users/fetchList',
  ({ accountId, ...searchParams }: ListParams<Ifilter[]>, thunk) => {
    let queryParams = searchParams;
    if (accountId) {
      queryParams = {
        ...queryParams,
        filters: [
          ...(queryParams.filters || []),
          {
            field: 'accountId',
            operands: [accountId],
            operator: FilterOperators.isAnyOf,
            validateInputs: false
          }
        ]
      };
    }
    return apiAsyncThunkCreator<{ users: IUser[] }, void>({
      endpoint: `users/list/${buildQueryParams(queryParams)}`,
      microservice: SERVICES.USERS_SERVICE_V2,
      authenticated: true,
      method: HttpMethods.Get
    })(undefined, thunk);
  }
);
